
import React, {Component} from "react";
import PageTitle from "../Components/Theme/PageTitle/index.js";
import DashboardLayout from "../Components/Theme/DashboardLayout/index.js";


export default class AdjustWorkTimes extends Component {

    render() {
        return (
            <DashboardLayout>
                {/*** Page Title ***/}
                <PageTitle title={'Adjust Work Times'}
                           subTitle={''}/>

            </DashboardLayout>
        )
    }
}
